import {inject, injectable} from 'inversify';
import {IoC} from 'app/ioc';
import {IAuthProvider} from '../../auth';
import {ILogger} from '../../logging';
import {ISearchServiceCustomers} from './searchService.customers.types';
import {execute, hasErrorsResponse} from 'app/utils';
import {SearchAPICallerCustomers} from 'app/api/searchAPI/customers/searchAPICaller.customers';
import {appConfig} from 'app/config';
import {ResponseError} from 'app/utils/responseError';
import {
    ICustomer,
    IGetCountryDetailsOptions,
    IGetCustomerDetailsOptions,
    ISearchCustomersOptions,
} from 'app/api/searchAPI/customers/searchAPICaller.customers.types';

@injectable()
export class SearchServiceCustomers implements ISearchServiceCustomers {
    @inject(IoC.AuthProvider) private readonly authProvider!: IAuthProvider;
    @inject(IoC.Logger) private readonly logger!: ILogger;

    public async searchCustomers(options: ISearchCustomersOptions) {
        return execute(
            async () => {
                const accessToken = await this.authProvider.getAccessToken();
                return await SearchAPICallerCustomers.searchCustomers(
                    options,
                    appConfig.skey_38,
                    accessToken
                );
            },
            (e: any) => {
                if (e instanceof ResponseError) {
                    throw e;
                } else {
                    this.logger.error(e);
                    return hasErrorsResponse([]) as ICustomer[];
                }
            }
        );
    }

    public async getCustomerDetails(options: IGetCustomerDetailsOptions) {
        return execute(
            async () => {
                const accessToken = await this.authProvider.getAccessToken();
                return await SearchAPICallerCustomers.getCustomerDetails(
                    options,
                    appConfig.skey_38,
                    accessToken
                );
            },
            (e: any) => {
                this.logger.error(e);

                if (e instanceof ResponseError) {
                    throw e;
                }

                return hasErrorsResponse();
            }
        );
    }

    public async getCountryDetails(options: IGetCountryDetailsOptions) {
        return execute(
            async () => {
                const accessToken = await this.authProvider.getAccessToken();
                return await SearchAPICallerCustomers.getCountryDetails(
                    options,
                    appConfig.skey_38,
                    accessToken
                );
            },
            (e: any) => {
                this.logger.error(e);
                return hasErrorsResponse();
            }
        );
    }
}
